import { Chip, CSSObject, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Tooltip from 'components/Tooltip'

export const DeprecatedFeatureChip = (): JSX.Element => {
  const { t } = useTranslation('components')

  return (
    <Tooltip content={t('deprecatedFeature.tooltip')}>
      <Chip
        label={t('deprecatedFeature.title')}
        size='small'
        sx={(theme: Theme): CSSObject => ({
          backgroundColor: theme.palette.grey[500],
        })}
        variant='filledWhiteText'
      />
    </Tooltip>
  )
}
